import {action, computed, Action, Computed} from 'easy-peasy';
import {simpleCrudStoreFactory, SimpleCrudStoreModel} from '@/utils/storeFactories';

interface ActionTypeChoice {
    id: number;
    name: string;
    value: string;
}

interface ActionEntity {
    id: number;
    title: string;
    actionTypeIdentifier: string;
    original: {
        id: number;
    };
    [key: string]: any;
}

export interface ActionStoreModel extends SimpleCrudStoreModel<ActionEntity> {
    addOrEditAction: Action<ActionStoreModel, ActionEntity>;
    actionTypeChoices: ActionTypeChoice[];
    loadActionTypeChoices: Action<ActionStoreModel, ActionTypeChoice[]>;
    actionsUsedInRules: Computed<ActionStoreModel, Set<number>>;
    actionHasRule: Computed<ActionStoreModel, (action: ActionEntity) => boolean>;
}

export default {
    ...simpleCrudStoreFactory(),
    addOrEditAction: action((state, action) => {
        // Implementation can be added here if needed
    }),
    actionTypeChoices: [] as ActionTypeChoice[],
    loadActionTypeChoices: action((state, actionTypeChoicesList) => {
        state.actionTypeChoices = actionTypeChoicesList;
    }),

    actionsUsedInRules: computed(
        [
            (state, storeState: any) => storeState.rules.items,
        ],
        (...args: any[]) => {
            const rules = args[0];
            const actionsInRules = new Set();

            rules.forEach((r: any) => actionsInRules.add(r.actionId));

            return actionsInRules;
        },
    ),
    actionHasRule: computed(
        [
            (state) => state.actionsUsedInRules,
            (state, storeState: any) => storeState.rules.loading,
        ],
        (...args: any[]) => (action: ActionEntity) => {
            const actionsUsedInRules = args[0];
            const rulesLoading = args[1];
            if (rulesLoading) {
                return true; // Default is true because we use it to detect whether action can be deleted
            }

            return actionsUsedInRules.has(action.original.id);
        },
    ),
} as ActionStoreModel;
